<ece-btn-icon
[text]="'user.grid.add.title' | i18n"
[icon]="'add'" (click)="add()"
></ece-btn-icon>
<ece-btn-icon
[text]="'user.grid.save.title' | i18n"
[icon]="'save'" (click)="save()"
></ece-btn-icon>


<div *ngFor="let role of roles; let i = index">
  <input kendoTextBox [(ngModel)]="role.name" required style="margin: 15px;" />
  <ece-btn-icon *ngIf="role.id == 0"
[text]="'user.grid.delete.title' | i18n"
[icon]="'delete'" (click)="delete(i)"
></ece-btn-icon>
    <kendo-expansionpanel
    *ngFor="let subject of role.subjects; index as i"
    [title]="subject.name">
    <div class="content">
      <div *ngFor="let action of subject.actions">
        <input type="checkbox"  kendoCheckBox [(ngModel)]="action.checked"/>
        <kendo-label>{{action.name}}</kendo-label>
      </div>
    </div>
  </kendo-expansionpanel>
  </div>

